import React, { useCallback } from "react";

import {
    StyleFunction,
    useAuth,
    useForm,
    useThemedStyle,
} from "@venuepos/react-common";
import { RootStackScreenProps } from "../../../navigation";
import {
    GQVirtualPrinterCreate,
    useVirtualPrinterCreateMutation,
} from "graphql-sdk";
import { defaultVirtualPrinter, schemaVirtualPrinter } from "lib";
import { useHandleMutationError } from "../../../hooks";
import { AdminContainer } from "../../container";
import { View } from "react-native";
import { Form } from "../form";
import { useTranslation } from "react-i18next";

type ScreenProps = RootStackScreenProps<"VIRTUAL_PRINTER_CREATE">;

export function VirtualPrinterCreateScreen({
    navigation: { navigate },
}: ScreenProps) {
    const auth = useAuth();
    auth.enforce("merchant.printer");

    const [t] = useTranslation();
    const [virtualPrinterCreate] = useVirtualPrinterCreateMutation();

    const form = useForm<GQVirtualPrinterCreate>(
        schemaVirtualPrinter,
        defaultVirtualPrinter
    );

    const [{ values }, { reset }] = form;
    const styles = useThemedStyle(styleFunc);
    const { handleMutationError } = useHandleMutationError();

    const handleSave = useCallback(async () => {
        if (!values) {
            return;
        }

        await handleMutationError(
            async () =>
                await virtualPrinterCreate({
                    variables: {
                        virtualPrinter: {
                            name: values.name,
                            printerId:
                                values.printerId !== ""
                                    ? values.printerId
                                    : undefined,
                            departments: values.departments,
                        },
                    },
                }),
            t("common.saved", "Saved"),
            () => {
                reset();
                navigate("VIRTUAL_PRINTERS", { refetch: true });
            }
        );
    }, [values, handleMutationError, t, virtualPrinterCreate, reset, navigate]);

    return (
        <AdminContainer>
            <View>
                <View style={styles.formBox}>
                    <Form
                        form={form}
                        onSubmit={handleSave}
                        submitButton={["common.save", "Save"]}
                    />
                </View>
            </View>
        </AdminContainer>
    );
}

const styleFunc: StyleFunction = theme => ({
    formBox: {
        maxWidth: theme.dimensions.maxFormWidth,
    },
});
